export default __webpack_public_path__ + "static/media/p3.336768b4.jpg";